// extracted by mini-css-extract-plugin
module.exports = {"item":"menu-item_item__xmvPc","price":"menu-item_price__3fyjv","title":"menu-item_title__27pAv"};